import { Music } from "lucide-react";
import TrackControls from "./TrackControls";

const TrackInfoPanel = ({ analysis, rotation, bpmAdjustment, trackNumber, isPlaying, onPlayPause, onRestart }) => {
  const duration = analysis?.duration || 0;
  const currentTime = duration > 0 ? (rotation / 360) * duration : 0;
  const adjustedBpm = analysis ? (analysis.bpm * bpmAdjustment).toFixed(0) : '--';

  return (
    <div className={`track-info-panel track-${trackNumber}`} data-testid={`track-info-${trackNumber}`}>
      <div className="track-info-row">
        <div className="info-stats">
          <div className="info-bpm">
            <span className="info-value">{adjustedBpm}</span>
            <span className="info-label">BPM</span>
          </div>
          <div className="info-time">
            <span className="info-value">
              {Math.floor(currentTime / 60)}:{String(Math.floor(currentTime % 60)).padStart(2, '0')}
            </span>
            <span className="info-label">/ {Math.floor(duration / 60)}:{String(Math.floor(duration % 60)).padStart(2, '0')}</span>
          </div>
        </div>
        <TrackControls 
          isPlaying={isPlaying}
          onPlayPause={onPlayPause}
          onRestart={onRestart}
          isActive={!!analysis}
          trackNumber={trackNumber}
        />
      </div>
      {isPlaying && <div className="playing-indicator"><Music size={14} /> Playing</div>}
    </div>
  );
};

export default TrackInfoPanel;
